<template>
  <div class="news-container">
    <NewsCard v-for="item in news.filter(e => e.isPublished).slice(0, 2)" :key="item.id" :vertical="vertical" :news="item" />
  </div>
</template>

<script>
import NewsCard from './NewsCard';

export default {
  components: { NewsCard },

  props: {
    news: {
      type: Array,
      required: true,
    },

    vertical: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.news-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 24px 0 80px;
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .news-container {
    margin-bottom: 0px;
  }
}
</style>
